import React, { useEffect, useState } from "react";
import OfferClasses from "./index.module.css";
import Layout from "Components/Layout";
import { Helmet } from "react-helmet";
import { Services } from "Services";
import SkeletonLoad from "Components/TableLoad/load";
import { Error, Error_Dark } from "Util/Toast";
import Moment from "react-moment";
import { useNavigate } from "react-router-dom";
import { FaRegEdit } from "react-icons/fa";
import { AccessControl } from "Util/AccessControl";
import { AccessKeys } from "Routes/config";

const getOfferStatus = (item) => {
    const today = new Date().toISOString().slice(0, 10);
    if (item.EffectiveFrom && today < item.EffectiveFrom) return "Upcoming";
    if (item.EffectiveTo && today > item.EffectiveTo) return "Expired";
    return "Live";
};

function Offers() {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const token = { Authorization: `token ${localStorage.getItem("token")}` };
    const Navigate = useNavigate();

    const getAllOffers = () => {
        setLoading(true);
        Services.getPublishedOffers("GET", null, token)
            .then((response) => {
                setTimeout(() => {
                    setLoading(false);
                }, 200);
                if (response.Status === 1) {
                    setData(response.Offers || []);
                } else if (response.Status === 0) {
                    Error(response.Message);
                }
            })
            .catch((err) => {
                setLoading(false);
                Error_Dark("something went wrong please try again");
                console.log(err);
            });
    };

    useEffect(() => {
        getAllOffers();
        // eslint-disable-next-line
    }, []);

    const addHandler = () => {
        Navigate("/Offers/add");
    };

    const editHandler = (e) => {
        e.stopPropagation();
        e.preventDefault();
        let slug = e.currentTarget.getAttribute("id");
        Navigate(`/Offers/edit/${slug}`);
    };

    const historyHandler = () => {
        Navigate("/Offers/history");
    };

    return (
        <Layout Active={"Offers"}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Offers</title>
            </Helmet>
            <div className={OfferClasses["Container"]}>
                {/* <div className={OfferClasses["control-btns"]}>
                    <button
                        className={OfferClasses["button"]}
                        onClick={addHandler}>
                        Add Offer
                    </button>
                </div> */}
                {AccessControl(AccessKeys.Offers)?.read === 1 && (
                    <div className={OfferClasses["control-btns"]}>
                        <button
                            className={OfferClasses["button"]}
                            onClick={historyHandler}>
                            View History
                        </button>
                    </div>
                )}
                <div className={OfferClasses["Tutor"]}>
                    <h3>Offers</h3>
                    {loading ? (
                        <SkeletonLoad
                            TableHead={[
                                "Title",
                                "Slug",
                                "Version",
                                "Effective",
                                // "Status",
                                "Actions",
                            ]}
                        />
                    ) : data.length > 0 ? (
                        <div className={OfferClasses["Table"]}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Title</th>
                                        <th>Slug</th>
                                        <th>Version</th>
                                        <th>Effective</th>
                                        {/* <th>Status</th> */}
                                        {AccessControl(AccessKeys.Offers)
                                            ?.edit === 1 && <th>Actions</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item) => {
                                        const status = getOfferStatus(item);
                                        return (
                                            <tr key={item.OfferPageID}>
                                                <td>{item.Title}</td>
                                                <td>{item.Slug}</td>
                                                <td>{item.Version}</td>
                                                <td>
                                                    <Moment format="DD-MM-YYYY">
                                                        {new Date(
                                                            item.EffectiveFrom
                                                        )}
                                                    </Moment>
                                                    {" - "}
                                                    {item.EffectiveTo ? (
                                                        <Moment format="DD-MM-YYYY">
                                                            {new Date(
                                                                item.EffectiveTo
                                                            )}
                                                        </Moment>
                                                    ) : (
                                                        "No expiry"
                                                    )}
                                                </td>
                                                {/* <td
                                                    className={
                                                        status === "Live"
                                                            ? OfferClasses[
                                                            "Status-active"
                                                            ]
                                                            : OfferClasses[
                                                            "Status-inactive"
                                                            ]
                                                    }>
                                                    <span>{status}</span>
                                                </td> */}
                                                {AccessControl(
                                                    AccessKeys.Offers
                                                )?.edit === 1 && (
                                                        <td>
                                                            <div
                                                                className={
                                                                    OfferClasses[
                                                                    "Action-btns"
                                                                    ]
                                                                }>
                                                                <button
                                                                    id={
                                                                        item.Slug
                                                                    }
                                                                    onClick={
                                                                        editHandler
                                                                    }
                                                                    title="Edit">
                                                                    <FaRegEdit />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    )}
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div>
                            <p>No Offers Found</p>
                        </div>
                    )}
                </div>
            </div>
        </Layout>
    );
}

export default Offers;
